// Shared by TrainingAttendeeList.js (read-only, from fetched attendance
// rows) and TrainingAttendance.js (live, recomputed from in-progress
// editing state) so both compute the same numbers the same way.
//
// result_1/result_2 are free-text fields (mixed numeric scores like "10"
// and non-numeric values like "Pass"/"A" in real data, by design — see
// NOTES.md) — the average silently skips any row whose value isn't a
// plain number, rather than tightening the field or erroring.
function isNumeric(value) {
  if (value === null || value === undefined) return false;
  const trimmed = String(value).trim();
  return trimmed !== '' && !isNaN(Number(trimmed));
}

function average(rows, key) {
  const numbers = rows.map(r => r[key]).filter(isNumeric).map(Number);
  if (numbers.length === 0) return null;
  return numbers.reduce((sum, n) => sum + n, 0) / numbers.length;
}

// rows: array of { attended, result_1, result_2 } — attended may be 0/1,
// '0'/'1', or boolean, matching how each caller already tracks it.
export function computeAttendanceStats(rows) {
  const total = rows.length;
  const attendedCount = rows.filter(r => Number(r.attended) === 1).length;

  return {
    total,
    attendedCount,
    attendanceRate: total > 0 ? (attendedCount / total) * 100 : null,
    avgResult1: average(rows, 'result_1'),
    avgResult2: average(rows, 'result_2'),
  };
}
